"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareWaitlistListInitialValues = exports.waitlistListEditFilter = exports.waitlistListCreateFilter = void 0;
const exchange_1 = require("@framework/exchange");
const waitlistListCreateFilter = ({ title, description, contractId, isPrivate, item }) => ({
    title,
    description,
    contractId,
    isPrivate,
    item: (0, exchange_1.cleanUpAsset)(item),
});
exports.waitlistListCreateFilter = waitlistListCreateFilter;
const waitlistListEditFilter = ({ title, description, isPrivate }) => ({
    title,
    description,
    isPrivate,
});
exports.waitlistListEditFilter = waitlistListEditFilter;
const prepareWaitlistListInitialValues = ({ id, title, description, item, contractId, isPrivate, }) => {
    return {
        id,
        title,
        description,
        item,
        contractId,
        isPrivate,
    };
};
exports.prepareWaitlistListInitialValues = prepareWaitlistListInitialValues;
//# sourceMappingURL=schemas.js.map